import axios from "axios";
import { authHeaderJson } from "./auth-header.service";

const requestExportToken = async (exportEndpoint) => {
    const response = await axios.post(
        '/api/export/token',
        { exportEndpoint },
        { headers: authHeaderJson() }
    );
    return response.data.token;
};

export { requestExportToken };
